var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var cleanUrlQuery = function (query) {
    var resultQuery = {};
    Object.keys(query).forEach(function (key) {
        if (query[key] != null) {
            resultQuery[key] = query[key];
        }
    });
    return resultQuery;
};
export var formatUrl = function (urlObject) {
    var protocol = urlObject.protocol, host = urlObject.host, pathname = urlObject.pathname, query = urlObject.query;
    var cleanedQueryString;
    if (query && typeof query === 'object') {
        // NOTE remove undefined or null values from query
        var cleanedQuery = cleanUrlQuery(query);
        cleanedQueryString = new URLSearchParams(cleanedQuery).toString();
    }
    else {
        cleanedQueryString = query;
    }
    return ((protocol ? "".concat(protocol, "//") : '') +
        (host !== null && host !== void 0 ? host : '') +
        pathname +
        (cleanedQueryString ? "?".concat(cleanedQueryString) : ''));
};
export var getUrlParams = function (url) {
    var searchParams = {};
    var iterableSearchParams = new URL(url).searchParams;
    iterableSearchParams.forEach(function (value, key) {
        searchParams[key] = value;
    });
    return searchParams;
};
export var getUrlHashParams = function (url) {
    var hashParams = {};
    var hash = new URL(url).hash;
    var iterableHashParams = new URLSearchParams(hash.substring(1));
    iterableHashParams.forEach(function (value, key) {
        hashParams[key] = value;
    });
    return hashParams;
};
export var addUrlParams = function (url, searchParams, hashParams) {
    if (!Object.keys(searchParams).length &&
        (!hashParams || !Object.keys(hashParams).length))
        return url;
    var _a = new URL(url), protocol = _a.protocol, host = _a.host, pathname = _a.pathname;
    var initialSearchParams = getUrlParams(url);
    var mergedSearchParams = cleanUrlQuery(__assign(__assign({}, initialSearchParams), searchParams));
    var search = new URLSearchParams(mergedSearchParams).toString();
    var urlSearch = search ? "?".concat(search) : '';
    var initialHashParams = getUrlHashParams(url);
    var mergedHashParams = cleanUrlQuery(__assign(__assign({}, initialHashParams), hashParams));
    var hash = new URLSearchParams(mergedHashParams).toString();
    var urlHash = hash ? "#".concat(hash) : '';
    return "".concat(protocol, "//").concat(host).concat(pathname).concat(urlSearch).concat(urlHash);
};
export var removeUrlHash = function (url) {
    var _a = new URL(url), protocol = _a.protocol, host = _a.host, pathname = _a.pathname, search = _a.search;
    return "".concat(protocol, "//").concat(host).concat(pathname).concat(search);
};
export var collectIdStats = function (href) {
    var _a = getUrlParams(href), src = _a.src, type = _a.type, param = _a.param, extra = _a.extra, _b = _a.rname, rname = _b === void 0 ? 'id' : _b;
    var formType = src || type || param || (rname !== 'id' && 'redirect') || 'self';
    return __assign({ project: rname, type: formType }, (extra && {
        extra: extra
    }));
};
export var collectUtmParams = function (href) {
    var urlParams = getUrlParams(href);
    var _a = urlParams.referer, referer = _a === void 0 ? document.referrer : _a;
    return Object.keys(urlParams).reduce(function (p, param) {
        var _a;
        return (__assign(__assign({}, p), (/^utm_(source|campaign|medium|content|term)$/.test(param) && (_a = {},
            _a[param] = urlParams[param],
            _a))));
    }, referer ? { referer: referer } : {});
};
export var getProviderOrigin = function (href) {
    return getUrlParams(href).iframeOrigin || document.referrer;
};
export var openedInIframe = function (href) {
    return getUrlParams(href).param === 'iframe' || window.parent !== window;
};
export var isOriginInvalid = function (href) {
    var host = new URL(href).host;
    return host !== 'id.rambler.ru';
};
export var checkRedirectDomain = function (href, allowedDomains) {
    if (href === void 0) { href = ''; }
    if (allowedDomains === void 0) { allowedDomains = []; }
    if (/^chrome-extension:\/\//.test(href)) {
        return true;
    }
    if (!allowedDomains || allowedDomains.length === 0) {
        return false;
    }
    var hostname = new URL(href, window.location.origin).hostname;
    var hostnameDomains = hostname.split('.');
    var firstLevelDomain = hostnameDomains.slice(-1).join('.');
    var secondLevelDomain = hostnameDomains.slice(-2).join('.');
    return allowedDomains.some(function (allowedDomain) {
        return allowedDomain === firstLevelDomain || allowedDomain === secondLevelDomain;
    });
};
export var getEmailOrderExtra = function (base, href) {
    var extra = __assign(__assign({}, base), { via: collectIdStats(href), utm: collectUtmParams(href) });
    return encodeURIComponent(JSON.stringify(extra));
};
export var getRedirectDeepLink = function (schema, defaultLink, allowedSchemas) {
    if (schema === void 0) { schema = ''; }
    if (defaultLink === void 0) { defaultLink = ''; }
    if (allowedSchemas === void 0) { allowedSchemas = []; }
    if (!allowedSchemas) {
        return;
    }
    var deepLink = ~allowedSchemas.indexOf("ramblerid".concat(schema))
        ? "ramblerid".concat(schema)
        : ~allowedSchemas.indexOf(schema)
            ? schema
            : null;
    if (deepLink && !~deepLink.indexOf('://')) {
        deepLink += "://".concat(defaultLink);
    }
    return deepLink;
};
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent
export var encodeURIComponentRFC3986 = function (value) {
    return encodeURIComponent(value).replace(/[!'()*]/g, function (c) { return "%".concat(c.charCodeAt(0).toString(16)); });
};
